import axios, { isAxiosError } from 'axios';
import { Base64 } from 'js-base64';
import queryString from 'query-string';
import { UniStorageFactory } from '../../helpers/uni-storage';
import { convertToErrorString } from '../../helpers/form/useErrorHandler';

export interface PasswordResetRequiredResponse {
  password_reset_token: string;
}

export class PasswordResetRequiredError extends Error {
  public password_reset_token: string;
  constructor(passwordResetToken: string) {
    super();

    this.message = 'Password_Reset_Required';
    this.password_reset_token = passwordResetToken;
  }
}

const clientId = 'web_client';
const clientSecret = '';

export const sendLogoutRequest = async () => {
  console.log(`The user has logged out.`);
  try {
    await axios
      .create()
      .post(
        `${UniStorageFactory.UniStorage.BackendUri}/connect/logout`,
        queryString.stringify({}),
        {
          maxRedirects: 0,
          headers: {
            Authorization: `Basic ${Base64.btoa(`${clientId}:${clientSecret}`)}`,
          },
        },
      );
  } catch (e) {
    if (isAxiosError(e)) {
      if (!e.request?.responseURL?.includes('/connect/logout')) {
        return;
      }
    }

    const errorMessage = convertToErrorString(e);
    alert(errorMessage);
    throw e;
  }
};

export const sendLoginRequest = async (
  userName: string,
  password: string,
): Promise<void> => {
  const accountAuthBody = {
    scope: 'offline_access',
    grant_type: 'password',
    username: userName,
    password: password,
  };

  console.log(`Login with userUname = '${userName}'`);
  return fetchTokenEndpoint(accountAuthBody);
};

export const sendRefreshTokenRequest = (): Promise<void> => {
  const requestBody = {
    grant_type: 'refresh_token',
  };

  return fetchTokenEndpoint(requestBody);
};

export const fetchTokenEndpoint = async (body: any): Promise<void> => {
  try {
    await axios
      .create()
      .post(
        `${UniStorageFactory.UniStorage.BackendUri}/connect/token`,
        queryString.stringify(body),
        {
          headers: {
            Authorization: `Basic ${Base64.btoa(`${clientId}:${clientSecret}`)}`,
          },
        },
      );
  } catch (e: any) {
    const response = e.response;
    if (e.message === 'Network Error') {
      throw new Error('Network_Error');
    } else if (response?.status === 400) {
      if (response.data?.error === 'invalid_grant') {
        const description = response.data?.error_description;
        if (description === 'locked') {
          throw new Error('Login_User_Locked');
        } else if (description === 'invalid_username_or_password') {
          throw new Error('Login_Failed');
        } else if (description === 'password_reset_required') {
          throw new PasswordResetRequiredError(
            (
              response.data as PasswordResetRequiredResponse
            ).password_reset_token,
          );
        } else if (description === 'login_failed_or_user_is_locked') {
          throw new Error(description);
        }
      }
    }
    console.error(e);
    throw new Error('Login_Unknown_Failure');
  }
};
